import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { CSidebar, CSidebarBrand, CSidebarNav, CRow } from '@coreui/react'
import AppSidebarNav from './AppSidebarNav'
import 'simplebar-react/dist/simplebar.min.css'
import Navigation from "../../../_nav";
import { getLogoUrl } from "../../../utils/logos";

const AppSidebar = (props) => {
	const COMPANY_CODE = process.env.REACT_APP_COMPANY_CODE;
	const EXPLICIT_FILE = process.env.REACT_APP_APP_LOGO || "";

	const dispatch = useDispatch()
	const unfoldable = useSelector((props) => props.state.sidebarUnfoldable)
	const sidebarShow = useSelector((props) => props.state.sidebarShow)
	const {user} = useSelector((props) => props.account);
	const [refreshKey, setRefreshKey] = useState(0);
	const logo = getLogoUrl({ code: COMPANY_CODE, file: EXPLICIT_FILE, fallback: 'default.svg' });

	const menu = Navigation();

	return (
		<CSidebar
			position="fixed"
			unfoldable={unfoldable}
			visible={sidebarShow}
			onVisibleChange={(visible) => {
				dispatch({ type: 'set', sidebarShow: visible })
			}}
		>
			<div className={"bg-zinc-900 flex-1"}>
				<CSidebarNav>
					<AppSidebarNav
						items={menu}
						setSelectedMenu={props.setSelectedMenu}
						refreshKey={refreshKey}
						setRefreshKey={setRefreshKey}
					/>
				</CSidebarNav>
			</div>
			<div className="p-2 bg-zinc-900 border-t border-gray-700">
				<div className={"flex flex-row items-center gap-2"}>
					<img className={"w-24"} src={logo} alt={""} />
					<div className={"flex flex-col"}>
						<span className="text-white text-md font-bold">{user ? user.userId : ""}</span>
						<span className="text-white text-sm">{user ? user.userName : ""}</span>
					</div>
				</div>
			</div>
		</CSidebar>
	)
}

export default React.memo(AppSidebar)
